import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import { ofType } from 'redux-observable';
import { Observable, OperatorFunction, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Action, ActionType } from 'typesafe-actions';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { CenterProductArticleType } from '@appTypes/centerProductArticleType';
import { Actions, actions } from '@redux/modules/centerProducts';
import { TypedEpic } from './types';

const fetchCenterProductsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_CENTER_PRODUCTS_WITH_ID),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getCenterProducts.request>[]
    >,
    switchMap(([action]: { payload: string; meta?: { id?: number } }[]) => {
      const url = ApiPaths[ApiType.apimNafNoApi].documents.get(action.payload);
      const params = action.meta?.id ? { centerId: action.meta.id } : undefined;

      return fromApiRequest((signal) =>
        apiClient.get<CenterProductArticleType>(ApiType.apimNafNoApi, {
          signal,
          url,
          params,
        }),
      ).pipe(
        map((response) => actions.getCenterProducts.success(response.data.products)),
        catchError((err) => of(actions.getCenterProducts.failure(toReduxError(err, GENERIC_FETCH_ERROR_MESSAGE)))),
      );
    }),
  );

export const epics: TypedEpic[] = [fetchCenterProductsEpic];
